const gallery = [
    {
        badge: 'snackView',
        image : 'assets/img/about/1.jpg'
    },
    {
        badge: 'innerRoom',
        image : 'assets/img/about/2.jpg'
    },
    {
        badge: 'riverView',
        image : 'assets/img/about/3.jpg'
    },
    {
        badge: 'roomDecoration',
        image : 'assets/img/about/4.jpg'
    },
    {
        badge: 'nightView',
        image : 'assets/img/about/5.jpg'
    },
    {
        badge: 'barView',
        image : 'assets/img/about/6.jpg'
    },
    {
        badge: 'riverView',
        image : 'assets/img/about/7.jpg'
    },
    {
        badge: 'innerRoom',
        image : 'assets/img/about/8.jpg'
    },
]
export default gallery

const gallery2 = [
    {
        id: 1,
        title: 'View from the sea',
        path : 'assets/img/about/1.jpg',
        category: ['restaurant']
    },
    {
        id: 2,
        title: 'View from the sea',
        path : 'assets/img/about/v1.jpg',
        category: ['landscape', 'hotel']
    },
    {
        id: 3,
        title: 'East terrace',
        path : 'assets/img/about/2.jpg',
        category: ['restaurant']
    },
    {
        id: 4,
        title: 'East terrace',
        path : 'assets/img/about/v2.jpg',
        category: ['hotel','landscape']
    },
    {
        id: 5,
        title: 'West terrace',
        path : 'assets/img/about/3.jpg',
        category: ['landscape']
    },
    {
        id: 6,
        title: 'West terrace',
        path : 'assets/img/about/v3.jpg',
        category: ['restaurant','hotel']
    },
    {
        id: 7,
        title: 'View from the beach',
        path : 'assets/img/about/4.jpg',
        category: ['hotel','restaurant']
    },
    {
        id: 8,
        title: 'View from the city',
        path : 'assets/img/about/7.jpg',
        category: ['restaurant']
    },
    {
        id: 9,
        title: 'View from the beach',
        path : 'assets/img/about/v4.jpg',
        category: ['landscape']
    },
    {
        id: 10,
        title: 'East terrace',
        path : 'assets/img/about/5.jpg',
        category: ['restaurant','hotel']
    },
    {
        id: 11,
        title: 'East terrace',
        path : 'assets/img/about/v5.jpg',
        category: ['hotel']
    },
    {
        id: 12,
        title: 'West terrace',
        path : 'assets/img/about/6.jpg',
        category: ['hotel']
    },
    {
        id: 13,
        title: 'Large parking',
        path : 'assets/img/about/8.jpg',
        category: ['restaurant']
    },
]
export {gallery2}